import { Accordion } from '@percent/lemonade'
import type { GivingRegionsConfigValue } from '@percent/admin-dashboard/api/types'
import { BadgeList } from './BadgeList'

type RegionsAccordionProps = {
  regions: GivingRegionsConfigValue
}

export function RegionsAccordion({ regions }: RegionsAccordionProps) {
  const entries = Object.values(regions)

  return (
    <Accordion>
      {entries.map(region => (
        <Accordion.Item key={region.id} value={region.id}>
          <Accordion.Control>{region.name}</Accordion.Control>
          <Accordion.Panel>
            <BadgeList items={region.countryCodes} />
          </Accordion.Panel>
        </Accordion.Item>
      ))}
    </Accordion>
  )
}
